<template>
  <u-animate-container id="top">
    <u-animate
      class="container"
      name="fadeInDown"
      delay="0s"
      duration="1s"
      :iteration="1"
      :offset="0"
      animateClass="animated"
      :begin="false"
    >
      <div class="left">
        <span class="enlarge" @click="enlarge_fontsize">A+</span>
        <span class="reduce" @click="reduce_fontsize">A-</span>
      </div>
      <div class="right">
        <span class="icon">
          <img src="@/assets/images/icon_earth.png" alt="" />
        </span>
        <span
          class="cn"
          :class="$i18n.locale == 'zh-cn' ? 'on' : ''"
          @click="switch_chinese"
          >中文</span
        >
        <span
          class="en"
          :class="$i18n.locale == 'en-us' ? 'on' : ''"
          @click="switch_english"
          >ENGLISH</span
        >
      </div>
    </u-animate>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  data() {
    return {
      locale: "zh-cn",
      rootFontSize: 0,
      maxFontSize: 0,
      minFontSize: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      var a = document.querySelector("html");
      var rootFontSize = getComputedStyle(a, null)["font-size"];
      // console.log(rootFontSize)
      this.rootFontSize = Number(rootFontSize.split("px")[0]);
      this.maxFontSize = this.rootFontSize + 20;
      this.minFontSize = this.rootFontSize - 20;
      // var rootFontSize = a.currentStyle['font-size'] ? a.currentStyle['font-size'] : getComputedStyle(a, null)['font-size']
    });
  },
  methods: {
    switch_english() {
      this.$i18n.locale = "en-us";
      window.localStorage.setItem("lang", "en-us");
      this.$emit("setLocale", "en-us");
      window.location.reload();
      // window.location.href = "http://www.sailuk-rivets.com/";
    },
    switch_chinese() {
      this.$i18n.locale = "zh-cn";
      window.localStorage.setItem("lang", "zh-cn");
      this.$emit("setLocale", "zh-cn");
      window.location.reload();
    },
    enlarge_fontsize() {
      var a = document.querySelector("html");
      if (this.rootFontSize < this.maxFontSize) {
        this.rootFontSize += 2;
        a.style.fontSize = this.rootFontSize;
      }
      console.log(this.rootFontSize);
      // console.log(this.maxFontSize)
      // console.log(this.minFontSize)
    },
    reduce_fontsize() {
      var a = document.querySelector("html");
      if (this.rootFontSize > this.minFontSize) {
        if (this.rootFontSize - 2 <= 12) {
          this.rootFontSize = 12;
        } else {
          this.rootFontSize -= 2;
        }
        a.style.fontSize = this.rootFontSize;
      }
      console.log(this.rootFontSize);
    }
  }
};
</script>

<style scoped lang="scss">
#top {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #333;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  .container {
    width: 1140px;
    margin: 0 auto;
    font-size: 14px;
    .left {
      float: Left;
      user-select: none;
      span {
        cursor: pointer;
        transition: all 0.35s;
        &:hover {
          color: #fd8204;
        }
        &.enlarge {
          margin-right: 15px;
        }
      }
    }
    .right {
      float: right;
      span {
        float: left;
        cursor: pointer;
        transition: all 0.35s;
        &:hover {
          color: #fd8204;
        }
        &.en {
          margin-left: 20px;
        }
        &.on {
          color: #fd8204;
        }
        &.icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
          img {
            width: 100%;
            height: auto;
            margin-top: 7px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #top {
    display: none;
    .container {
      width: 100%;
      box-sizing: border-box;
      padding: 0 1rem;
      font-size: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Common/Header.vue